<script>
export default {
  name: 'CtaCalendly',

  props: {
    url: String,
    label: String,

    classes: {
      default: '',
      type: String,
    },
  },

  methods: {
    openLink() {
      // eslint-disable-next-line no-undef
      Calendly.initPopupWidget({ url: this.url })
    },
  },
}
</script>

<template>
  <button
    :class="classes"
    class="btn mb-8"
    @click="openLink">
    {{ label }}
  </button>
</template>
